import { render, staticRenderFns } from "./OrderUserList.vue?vue&type=template&id=4c6f2a73&"
import script from "./OrderUserList.vue?vue&type=script&lang=js&"
export * from "./OrderUserList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports